import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setAnswer } from '../../actions/questionActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { notifySuccess, notifyError } from '../Toast';

const Archivo = ({ title, idPregunta, requerida = false, showError = false }) => {
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState('');

  const answers = useSelector(state => state.question.answers);
  const answerValue = answers[idPregunta]?.fileName || '';

  useEffect(() => {    
    if (answerValue) {
      setFileName(answerValue);
    }
  }, [answerValue]);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const maxSizeBytes = 10 * 1024 * 1024; 
      if (file.size > maxSizeBytes) {
        notifyError("El archivo no debe superar los 10 MB");
        setFileName(undefined)
        return;
      }
      setFileName(file.name);
      // Recuperar el answerId anterior si existe
      const prevAnswer = answers[idPregunta];
      let answerObj = { answer: file };
      if (prevAnswer && prevAnswer.answerId) {
        answerObj.answerId = prevAnswer.answerId;
      }
      
      dispatch(setAnswer(idPregunta, answerObj.answer, undefined, answerObj.answerId));
    }
  };

  return (
    <div>
      <Form.Group className="tipo-de-credencial-parent mb-3">
        <Form.Label className='nombre'>
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </Form.Label>
        <input
          type="file"
          id="file-input"
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />
        <label htmlFor="file-input" className="attachment-button mb-3">
          <FontAwesomeIcon icon={faPaperclip} className="attachment-icon" />
          {fileName || "Adjuntar archivo"}
        </label>
        {requerida && showError && (
          <div style={{ color: '#C2185B', fontSize: '1em', marginTop: '8px' }}>
            Debe adjuntar un archivo para continuar
          </div>
        )}
      </Form.Group>
    </div>
  );
};

export default Archivo;
